/* ChicChac — product-card enhancement (progressive, self-contained)
   Founder change-set (docs/chicchac-design-A-changes.docx):
   - 2 PERMANENT (non-hover) buttons at the top of every card: Wishlist + Add to Cart
   - % OFF badge relocated from the top corner to the BOTTOM of the card (by the price)
   Works on collection grid, home product blocks, search results, related products.
   Wishlist persists to localStorage; Add to Cart uses Shopify AJAX + refreshes the
   Horizon cart bubble. No external dependencies. */
(function () {
  'use strict';
  var WKEY = 'cc_wishlist';

  function wl() { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } }
  function saveWl(a) {
    try { localStorage.setItem(WKEY, JSON.stringify(a)); } catch (e) {}
    /* keep the header wishlist count (cc-wishlist.js) in sync */
    try { document.dispatchEvent(new CustomEvent('cc:wishlist', { bubbles: true })); } catch (e) {}
  }
  function inWl(h) { return wl().indexOf(h) > -1; }
  function toggleWl(h) { var a = wl(), i = a.indexOf(h); if (i > -1) a.splice(i, 1); else a.push(h); saveWl(a); return i < 0; }

  var HEART = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M12 21s-7.5-4.9-10-9.2C.6 9 1.7 5.6 4.8 5c1.9-.3 3.5.6 4.4 2 .9-1.4 2.5-2.3 4.4-2 3.1.6 4.2 4 2.8 6.8C19.5 16.1 12 21 12 21z"/></svg>';
  var BAG = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M6 8h12l-1 12H7L6 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>';

  function toast(msg) {
    var t = document.getElementById('cc-toast');
    if (!t) { t = document.createElement('div'); t.id = 'cc-toast'; t.className = 'cc-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 2200);
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[ref="cartBubbleCount"], .cart-bubble__text-count').forEach(function (el) {
          el.textContent = c.item_count; el.classList.remove('hidden');
        });
        document.querySelectorAll('.cart-bubble').forEach(function (b) { if (c.item_count > 0) b.classList.remove('visually-hidden'); });
        try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
        return c;
      });
  }

  // Re-render Horizon's cart drawer with the freshly-added line via the Section
  // Rendering API, so the drawer isn't stale until a page reload.
  function updateCartDrawer(sections) {
    if (!sections) return;
    var id = 'cart-drawer-section';
    var html = sections[id];
    if (!html) return;
    var target = document.getElementById('shopify-section-' + id);
    if (!target) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var inner = tmp.querySelector('#shopify-section-' + id);
    target.innerHTML = inner ? inner.innerHTML : html;
  }

  function addToCart(variantId, btn) {
    if (!variantId) { toast('Currently unavailable'); return; }
    btn.classList.add('is-loading'); btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: 'cart-drawer-section',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (res) { updateCartDrawer(res && res.sections); return refreshCart(); })
      .then(function () { toast('Added to cart'); })
      .catch(function () { toast('Could not add to cart'); })
      .then(function () { btn.classList.remove('is-loading'); btn.disabled = false; });
  }

  function variantFromHref(href) { var m = href && href.match(/[?&]variant=(\d+)/); return m ? m[1] : null; }
  function handleFromHref(href) { var m = href && href.match(/\/products\/([^/?#]+)/); return m ? m[1] : null; }

  function enhance(card) {
    if (card.__ccDone) return; card.__ccDone = true;
    var gallery = card.querySelector('.card-gallery');
    if (!gallery) return;
    var link = card.querySelector('a.product-card__link') || card.querySelector('a[href*="/products/"]');
    var href = link ? link.getAttribute('href') : null;
    var handle = handleFromHref(href) || card.getAttribute('data-product-id');
    var variant = variantFromHref(href);

    /* --- two permanent action buttons, top of the card media --- */
    var bar = document.createElement('div');
    bar.className = 'cc-card-actions';

    var fav = document.createElement('button');
    fav.type = 'button'; fav.className = 'cc-card-btn cc-card-fav';
    fav.setAttribute('aria-label', 'Add to wishlist'); fav.innerHTML = HEART;
    if (handle && inWl(handle)) fav.classList.add('is-active');
    fav.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var on = toggleWl(handle);
      fav.classList.toggle('is-active', on);
      fav.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
      toast(on ? 'Saved to wishlist' : 'Removed from wishlist');
    });

    var atc = document.createElement('button');
    atc.type = 'button'; atc.className = 'cc-card-btn cc-card-atc';
    atc.setAttribute('aria-label', 'Add to cart'); atc.innerHTML = BAG;
    atc.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      if (variant) { addToCart(variant, atc); return; }
      if (handle) {
        fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
          var v = (p.variants.filter(function (x) { return x.available; })[0] || p.variants[0]);
          addToCart(v && v.id, atc);
        }).catch(function () { toast('Could not add to cart'); });
      }
    });

    bar.appendChild(fav); bar.appendChild(atc);
    gallery.appendChild(bar);

    /* --- relocate the % OFF badge to the bottom, by the price --- */
    var badgeLeaf = Array.prototype.slice.call(gallery.querySelectorAll('*')).filter(function (el) {
      return el.children.length === 0 && /\d+%\s*OFF/i.test(el.textContent || '');
    })[0];
    if (badgeLeaf) {
      var pct = (badgeLeaf.textContent.match(/\d+%\s*OFF/i) || [''])[0].toUpperCase().replace(/\s+/g, ' ');
      var price = card.querySelector('product-price, .price');
      var pill = document.createElement('span');
      pill.className = 'cc-card-off';
      pill.textContent = pct;
      if (price && price.parentNode) price.parentNode.insertBefore(pill, price.nextSibling);
      else (card.querySelector('.product-card__content') || card).appendChild(pill);
      var container = badgeLeaf.closest('[class*="badge"]') || badgeLeaf;
      container.style.display = 'none';
    }
  }

  function run(root) { (root || document).querySelectorAll('product-card').forEach(enhance); }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', function () { run(); });

  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.tagName === 'PRODUCT-CARD') enhance(n);
        else if (n.querySelectorAll) n.querySelectorAll('product-card').forEach(enhance);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
